
export { PredialService } from "./predial.service";
